<template>
  <!-- クレジットカード -->
  <section class="section">
    <div class="section__header">
      <h4 class="section__name">{{ $t('models.storePaymentMethod.creditCard') }}</h4>
      <div class="section__radio">
        <KkRadioGroup
          :model-value="paymentMethods.creditCard.available"
          :items="paymentMethodsOptions('creditCard')"
          name="creditCard"
          @update:model-value="value => $emit('change-attributes', ({ type: 'creditCard', target: 'available', value: value }))"
        />
      </div>
    </div>
    <div v-if="paymentMethods.creditCard.available === 'ok'" class="section__body">
      <p class="toggle">
        <button
          type="button"
          class="toggle__target"
          :class="{ 'is-show': details.creditCard }"
          @click="details.creditCard = !details.creditCard"
        >
          {{ $t('components.PaymentMethods.specifyBrand') }}
        </button>
      </p>
      <ul v-if="details.creditCard" class="paymentMethods">
        <li v-for="creditCardType in creditCardTypes" :key="creditCardType" class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t(`models.storePaymentMethod.creditCards.${creditCardType}`) }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.creditCard[creditCardType]"
              :items="paymentMethodsOptions(creditCardType)"
              :name="creditCardType"
              @update:model-value="value => $emit('change-attributes', ({ type: 'creditCard', target: creditCardType, value: value }))"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
  <!-- 電子マネー -->
  <section class="section">
    <div class="section__header">
      <h4 class="section__name">{{ $t('models.storePaymentMethod.electronicMoney') }}</h4>
      <div class="section__radio">
        <KkRadioGroup
          :model-value="paymentMethods.electronicMoney.available"
          :items="paymentMethodsOptions('electronicMoney')"
          name="electronicMoney"
          @update:model-value="value => $emit('change-attributes', ({ type: 'electronicMoney', target: 'available', value: value }))"
        />
      </div>
    </div>
    <div v-if="paymentMethods.electronicMoney.available === 'ok'" class="section__body">
      <p class="toggle">
        <button
          type="button"
          class="toggle__target"
          :class="{ 'is-show': details.electronicMoney }"
          @click="details.electronicMoney = !details.electronicMoney"
        >
          {{ $t('components.PaymentMethods.specifyBrand') }}
        </button>
      </p>
      <ul v-if="details.electronicMoney" class="paymentMethods">
        <li v-for="electronicMoneyType in electronicMoneyTypes" :key="electronicMoneyType" class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t(`models.storePaymentMethod.electronicMoneys.${electronicMoneyType}`) }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.electronicMoney[electronicMoneyType]"
              :items="paymentMethodsOptions(electronicMoneyType)"
              :name="electronicMoneyType"
              @update:model-value="value => $emit('change-attributes', ({ type: 'electronicMoney', target: electronicMoneyType, value: value }))"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
  <!-- 交通系電子マネー -->
  <section class="section">
    <div class="section__header">
      <h4 class="section__name">{{ $t('models.storePaymentMethod.transportationElectronicMoney') }}</h4>
      <div class="section__radio">
        <KkRadioGroup
          :model-value="paymentMethods.transportationElectronicMoney.available"
          :items="paymentMethodsOptions('transportationElectronicMoney')"
          name="transportationElectronicMoney"
          @update:model-value="value => $emit('change-attributes', ({ type: 'transportationElectronicMoney', target: 'available', value: value }))"
        />
      </div>
    </div>
    <div v-if="paymentMethods.transportationElectronicMoney.available === 'ok'" class="section__body">
      <p class="toggle">
        <button
          type="button"
          class="toggle__target"
          :class="{ 'is-show': details.transportationElectronicMoney }"
          @click="details.transportationElectronicMoney = !details.transportationElectronicMoney"
        >
          {{ $t('components.PaymentMethods.specifyBrand') }}
        </button>
      </p>
      <ul v-if="details.transportationElectronicMoney" class="paymentMethods">
        <li v-for="transportationElectronicMoneyType in transportationElectronicMoneyTypes" :key="transportationElectronicMoneyType" class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t(`models.storePaymentMethod.transportationElectronicMoneys.${transportationElectronicMoneyType}`) }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.transportationElectronicMoney[transportationElectronicMoneyType]"
              :items="paymentMethodsOptions(transportationElectronicMoneyType)"
              :name="transportationElectronicMoneyType"
              @update:model-value="value => $emit('change-attributes', ({ type: 'transportationElectronicMoney', target: transportationElectronicMoneyType, value: value }))"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
  <!-- QRコード決済 -->
  <section class="section">
    <div class="section__header">
      <h4 class="section__name">{{ $t('models.storePaymentMethod.qrCodePayment') }}</h4>
      <div class="section__radio">
        <KkRadioGroup
          :model-value="paymentMethods.qrCodePayment.available"
          :items="paymentMethodsOptions('qrCodePayment')"
          name="qrCodePayment"
          @update:model-value="value => $emit('change-attributes', ({ type: 'qrCodePayment', target: 'available', value: value }))"
        />
      </div>
    </div>
    <div v-if="paymentMethods.qrCodePayment.available === 'ok'" class="section__body">
      <p class="toggle">
        <button
          type="button"
          class="toggle__target"
          :class="{ 'is-show': details.qrCodePayment }"
          @click="details.qrCodePayment = !details.qrCodePayment"
        >
          {{ $t('components.PaymentMethods.specifyBrand') }}
        </button>
      </p>
      <ul v-if="details.qrCodePayment" class="paymentMethods">
        <li v-for="qrCodePaymentType in qrCodePaymentTypes" :key="qrCodePaymentType" class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t(`models.storePaymentMethod.qrCodePayments.${qrCodePaymentType}`) }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.qrCodePayment[qrCodePaymentType]"
              :items="paymentMethodsOptions(qrCodePaymentType)"
              :name="qrCodePaymentType"
              @update:model-value="value => $emit('change-attributes', ({ type: 'qrCodePayment', target: qrCodePaymentType, value: value }))"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
  <!-- その他決済 -->
  <section class="section">
    <div class="section__header">
      <h4 class="section__name">{{ $t('models.storePaymentMethod.other') }}</h4>
    </div>
    <div class="section__body">
      <ul class="paymentMethods">
        <li class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t('models.storePaymentMethod.cashOnly') }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.cashOnly.available"
              :items="paymentMethodsOptions('cashOnly')"
              name="cashOnly"
              @update:model-value="value => $emit('change-attributes', ({ type: 'cashOnly', target: 'available', value: value }))"
            />
          </div>
        </li>
        <li class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t('models.storePaymentMethod.debitCard') }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.debitCard.available"
              :items="paymentMethodsOptions('debitCard')"
              name="debitCard"
              @update:model-value="value => $emit('change-attributes', ({ type: 'debitCard', target: 'available', value: value }))"
            />
          </div>
        </li>
        <li class="paymentMethods__item">
          <label class="paymentMethods__name">{{ $t('models.storePaymentMethod.payCheck') }}</label>
          <div class="paymentMethods__radio">
            <KkRadioGroup
              :model-value="paymentMethods.payCheck.available"
              :items="paymentMethodsOptions('payCheck')"
              name="payCheck"
              @update:model-value="value => $emit('change-attributes', ({ type: 'payCheck', target: 'available', value: value }))"
            />
          </div>
        </li>
      </ul>
    </div>
  </section>
</template>

<script>
import {
  PaymentMethodStatuses,
  creditCardTypes,
  electronicMoneyTypes,
  transportationElectronicMoneyTypes,
  qrCodePaymentTypes,
} from '../modules/paymentMethodConst'
import { KkRadioGroup } from '../components/base'

export default {
  name: 'PaymentMethods',
  components: {
    KkRadioGroup,
  },
  props: {
    paymentMethods: {
      type: Object,
      required: true,
    },
    statuses: {
      type: Array,
      default: () => PaymentMethodStatuses,
    },
  },
  emits: ['change-attributes'],
  data () {
    return {
      details: {
        creditCard: true,
        electronicMoney: true,
        transportationElectronicMoney: true,
        qrCodePayment: true,
      },
    }
  },
  computed: {
    creditCardTypes: () => creditCardTypes,
    electronicMoneyTypes: () => electronicMoneyTypes,
    transportationElectronicMoneyTypes: () => transportationElectronicMoneyTypes,
    qrCodePaymentTypes: () => qrCodePaymentTypes,
  },
  created() {
    if (this.paymentMethods.creditCard.available === 'ok') {
      this.details.creditCard = true
    }
    if (this.paymentMethods.electronicMoney.available === 'ok') {
      this.details.electronicMoney = true
    }
    if (this.paymentMethods.transportationElectronicMoney.available === 'ok') {
      this.details.transportationElectronicMoney = true
    }
    if (this.paymentMethods.qrCodePayment.available === 'ok') {
      this.details.qrCodePayment = true
    }
  },
  methods: {
    paymentMethodsOptions(type) {
      return [
        {
          id: `${type}ok`,
          value: 'ok',
          text: this.$t('components.PaymentMethods.options.ok'),
        },
        {
          id: `${type}ng`,
          value: 'ng',
          text: this.$t('components.PaymentMethods.options.ng'),
        },
        {
          id: `${type}na`,
          value: 'na',
          text: this.$t('components.PaymentMethods.options.na'),
        },
      ]
    },
    changeAttribute({type, target, value}) {
      this.$emit('change-attributes', ({ type: type, target: target, value: value }))
    },
  }
}
</script>

<style lang="scss" scoped>
@import '../../../stylesheets/biz_spa/foundation/_var.scss';
@import '../../../stylesheets/biz_spa/foundation/_mixin.scss';
.section {
  margin-top: 24px;
  padding: 16px;
  border-radius: 4px;
  border: 1px solid #E4E7EB;
  box-shadow: 0 0 0 0 rgba(63, 63, 68, .05);
  &__name {
    font-size: 14px;
    font-weight: bold;
    letter-spacing: 1px;
  }
  &__body {
    margin-top: 16px;
  }
  @include mq(lg) {
    padding: 16px 32px;
    &__header {
      display: flex;
      justify-content: space-between;
      align-items: center;
    }
    &__radio {
      margin-top: -8px;
    }
  }
}
.toggle {
  &__target {
    display: flex;
    align-items: center;
    font-size: 12px;
    line-height: 1.5;
    cursor: pointer;
    &::after {
      display: block;
      width: 8px;
      height: 4px;
      margin-left: 10px;
      background: #3A3B3F;
      clip-path: polygon(0 0, 100% 0%, 50% 100%);
      content: "";
    }
    &.is-show::after {
      transform: rotate(180deg);
    }
  }
}
.paymentMethods {
  margin-top: 16px;
  &__item {
    margin-top: 8px;
    padding: 16px;
    border-radius: 4px;
    border: 1px solid #E4E7EB;
    line-height: 1;
  }
  &__name {
    font-size: 14px;
    line-height: 1;
    letter-spacing: .15px;
  }
  @include mq(lg) {
    &__item {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 24px;
    }
    &__radio {
      margin-top: -8px;
    }
  }
}

</style>
